import { Injectable, OnDestroy } from "@angular/core";
import * as Sentry from '@sentry/angular';
import { MapHelperService } from "../../../../../../services/map-helper.service";
import { EstatusJSON } from "../../../../shared/models/EstatusJSON";
import { environment } from "../../../../../../environments/environment";
import { BehaviorSubject, filter, Subject, Subscription } from "rxjs";
import { LayerDTO } from "../models/LayerDTO";
import { EnumLayerTypes } from "../../../../shared/helpers/enums/EnumLayerTypes";
import { LocationCategoriesService } from "./LocationCategories.service";
import { LayerService } from "./Layers.service";
import { LocationsService } from "./Locations.service";
import { LocationsMapService } from "./LocationsMap.service";
import { MatDialog } from "@angular/material/dialog";
import { LocalStorageService } from "../../../../shared/services/LocalStorage.service";
import { PanelLocationsService } from "./Panel-Locations.service";
import { CategoryFiltersDTO } from "../../../../shared/models/CategoryFilters/CategoryFilters";
import { FilterDialogData, FilterDialogResult, SelectedFilter } from "../models/Filters";
import { EnumPanelGPSTabTypes } from "../enums/EnumPanelGPSTabTypes";
import { FilterCategoriesComponent } from "../components/2-panel-locations/organisms/filters/filters-categories/filter-categories.component";
import { LocationCategoryDTO } from "../models/LocationCategoryDTO";
@Injectable({
  providedIn: "root",
})
export class PanelInternalLayerService implements OnDestroy {
  isExpandCollapseAnimating: boolean = false;

  dataGeoJson: any;
  configUrl: string;
  // capas = new Array<LayerDTO>();
  capasPivote = new Array<LayerDTO>();
  filterDialog: any;

  private intersectedFeatures$: Subject<any> = new Subject<any>();
  public capas$: BehaviorSubject<LayerDTO[]> = new BehaviorSubject<LayerDTO[]>([]);

  activeLayerGpsTypeSelected: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  activeLayer: LayerDTO = {name: "layer-locationsGeneral", checked: false, idLayerType: 1, isVisible: false, categoryId: null, atributeDisplay: null, icon: null, id: null, layerType: null, atributes: null, itWorksAsVirtualLocation: false, isLoading: false, isFilteredLayer: false, hasBeenFiltered: false, mapSourceId: ["pointsSource"]};

  //ultimo geojson de tab gps recibido, se guarda solo para reaplicarlo si el mapa aún no estaba listo cuando llegó
  private lastGpsLayerData: { gpsType: string, geoJson: any } = null;

  isFilterLayer: boolean = false;
  filterLayerFiltersBackup: SelectedFilter[] = null;
  filterLayer: LayerDTO = {name: "filter-layer-locationsGeneral", checked: false, idLayerType: 1, isVisible: false, categoryId: null, atributeDisplay: null, icon: null, id: null, layerType: null, atributes: null, itWorksAsVirtualLocation: false, isLoading: false, isFilteredLayer: false, hasBeenFiltered: false, mapSourceId: ["filterPointsSource"]};

  geofenceLayer: LayerDTO = {name: "Geocercas", checked: null, idLayerType: 1, isVisible: null, categoryId: null, atributeDisplay: null, icon: null, id: null, layerType: null, atributes: null, itWorksAsVirtualLocation: false, isLoading: false, isFilteredLayer: false, hasBeenFiltered: false, mapSourceId: [""]};

  isInternalLayersExpanded: boolean = true;
  isVirtualLayersExpanded: boolean = true;
  
  private layerSubscriptions: Map<string, Subscription> = new Map();
  subscription_AfterClosed: Subscription;

  constructor(
    private mapHelper: MapHelperService,
    private locationsMapService: LocationsMapService,
    private locationCategoriesService: LocationCategoriesService,
    private locationService: LocationsService,
    private layerService : LayerService,
    private dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private panelLocationsService: PanelLocationsService

  ) {
    this.configUrl = environment.host;

    this.panelLocationsService.tabCategoryFiltersSelected.pipe(
      filter(t => t != null && t.categoryToBeAffected != null )
    ).subscribe((selected) => {
      const category = selected.categoryToBeAffected;
      const filterForCategory = selected.filters.find(f => f.id == category.id.toString());
      
      const layer = this.capas$.value.find(l => l.categoryId == category.id);
      if (!layer) 
        return;

      if (!filterForCategory || filterForCategory.filtersSelected?.length === 0) {
        this.DeactivateLayer(layer);
        return;
      }
      
      const filtersApplied = filterForCategory.filtersSelected.map(f => ({
        Key: f.key, Value: f.value, Module: f.module || ''
      }));

      this.loadLayer(layer, filtersApplied);
    });

    this.mapHelper.mainSource$.pipe(
      filter(location => location && location.isMainSourceReady && location.isStyleReady)
    ).subscribe(() => {
      setTimeout(() => {
        if (this.activeLayer.checked && this.lastGpsLayerData && this.lastGpsLayerData.gpsType === this.activeLayerGpsTypeSelected.value) {
          this.mapHelper.UpdateLayerGeoJson(this.activeLayer.mapSourceId[0], this.lastGpsLayerData.geoJson);
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeAllLayers();
    if (this.subscription_AfterClosed) {
      this.subscription_AfterClosed.unsubscribe();
    }
  }
  
  getLayers(): any {
    return this.capas$.asObservable();
  }

  setGeofenceToggle(resp){
    this.capas$.next(resp);
  }

  //crea las capas del lado interno
  createMapLayer(layer : LayerDTO) {
    if(!environment.production) console.log("MapLayer", layer)
    var existingLayer = this.mapHelper.GetLayerByName(layer.name + "-layer");
    if (existingLayer != null && existingLayer != undefined || this.capas$.value.some((v) => v.name === layer.name))
      return;

    if(!environment.production) console.log("MapLayer", layer);

    switch (layer.idLayerType) {
      case EnumLayerTypes.Point:
        layer.mapSourceId = [layer.name + "-source"];
        this.mapHelper.AddSourceEmptyGeoJson(layer.mapSourceId[0], "Puntos de " + layer.name, layer.icon, undefined, layer.atributeDisplay);
        this.mapHelper.AddLayerText(
          layer.name + "text-layer",
          layer.mapSourceId[0],
          layer.atributeDisplay,
          "Etiqueta de " + layer.name,
          -2
        );
        this.mapHelper.AddLayerIcon(
          layer.name + "-layer",
          layer.mapSourceId[0],
          layer.icon,
          "Puntos de " + layer.name,
          this.locationsMapService.generalMapIconSize
        );
        
        break;
      case EnumLayerTypes.Lines:
        layer.mapSourceId = [layer.name + "-source"];
        this.mapHelper.AddSourceEmptyGeoJson(layer.mapSourceId[0], "Líneas de " + layer.name, 'annotation-line.png');
        this.mapHelper.AddLayerLine(
          layer.name + "-layer",
          layer.mapSourceId[0],
          "Líneas de " + layer.name,
          "#352F84",
          5,
        );
        break;
      case EnumLayerTypes.Polygon:
        layer.mapSourceId = [layer.name + "-source"];
        this.mapHelper.AddSourceEmptyGeoJson(layer.mapSourceId[0], "Polígonos de " + layer.name, 'annotation-polygon.png');
        this.mapHelper.AddLayerCustomizablePolygons(
          layer.name + "-layer",
          layer.mapSourceId[0],
          0.4,
          "Polígonos de " + layer.name
        );
        this.mapHelper.AddLayerText(
          layer.name + "text-layer",
          layer.mapSourceId[0],
          layer.atributeDisplay,
          "Etiqueta de " + layer.name,
          -4
        );
        break;
      case EnumLayerTypes.Geofence:
        layer.mapSourceId = [layer.name + "-source", layer.name + "-highsource"];
        var existingGeofenceLayer = this.mapHelper.GetLayerByName("geofences-layer");
        if (existingGeofenceLayer != null && existingGeofenceLayer != undefined)
          return;

        if(!environment.production) console.log("Updating*******************************LayerGeoJson", layer.name + "-highSource");
        this.mapHelper.AddSourceHighEmptyGeoJson(layer.mapSourceId[1], "Indicador de geocercas", 'geofence.png');
        this.mapHelper.AddSourceEmptyGeoJson(layer.mapSourceId[0], "Geocercas", 'annotation-geofence-polygon.png');
        this.mapHelper.AddLayerGeofencesPolygons(
          "geofences-layer",
          layer.mapSourceId[0],
          "Geocercas"
        );
        this.mapHelper.AddLayerGeofencesByStatus(
          "geofencesStatus-layer",
          layer.mapSourceId[1],
          "Estado de geocercas"
        );
        this.mapHelper.AddLayerTextH3WithStatus(
          "GeofenceText-layer",
          layer.mapSourceId[0],
          "Name",
          "Etiqueta de geocercas"
        );
        break;
      case EnumLayerTypes.ClusterPoints:
        layer.mapSourceId = [layer.name + "-source"];
        var existingClusterLayer = this.mapHelper.GetLayerByName(layer.name + "-layerCluster");
        if (existingClusterLayer != null && existingClusterLayer != undefined)
          return;

        this.mapHelper.AddSourceClusteredEmptyGeoJson(layer.mapSourceId[0], layer.name, layer.icon, undefined, layer.atributeDisplay);
        this.mapHelper.AddLayerCluster(
          layer.name + "-layerCluster",
          layer.mapSourceId[0],
          "Clusters de " + layer.name
        );
        this.mapHelper.AddClusterZoomEvent(layer.name + "-layerCluster", layer.mapSourceId[0]);
        this.mapHelper.AddLayerClusterCount(
          layer.name + "-layerClusterCount",
          layer.mapSourceId[0],
          "Conteo de clusters de " + layer.name
        );

        this.mapHelper.AddLayerUnclusteredPointsV2(
          layer.name + "-layer",
          layer.mapSourceId[0],
          layer.icon,
          "Puntos de " + layer.name,
          this.locationsMapService.generalMapIconSize
        );

        this.mapHelper.AddLayerText(
          layer.name + "text-layer",
          layer.mapSourceId[0],
          layer.atributeDisplay,
          "Etiqueta de " + layer.name,
          -2
        );
        break;
      case EnumLayerTypes.PrecalculatedPolygon:
        layer.mapSourceId = [layer.name + "-source"];
        this.mapHelper.AddSourceEmptyGeoJson(layer.mapSourceId[0], "Polígonos precalculados de " + layer.name, 'annotation-precalculated-polygon.png');
        this.mapHelper.AddLayerCustomizablePolygons(
          layer.name + "-layer",
          layer.mapSourceId[0],
          0.4,
          "Polígonos precalculados de " + layer.name,
          "#b59df8"
        );
        this.mapHelper.AddLayerLine( 
          layer.name + "-layer-line", 
          layer.mapSourceId[0],
          "Líneas de " + layer.name,
          "#6e3afc",
          3,
        );
        this.mapHelper.AddLayerText(
          layer.name + "text-layer",
          layer.mapSourceId[0],
          layer.atributeDisplay,
          "Etiqueta de " + layer.name,
          -4
        );
      default:
        break;
    }
    this.capas$.next([...this.capas$.value, layer]);
  }

  //se acciona al presionar el switch de una capa, capaActivada es el evento seleciconado
  onToggleLayer(layer: LayerDTO) {
    const filteredLayer = this.capas$.value.find((value) => {
      return value.name == layer.name;
    });
    if (filteredLayer != undefined) {
      if (!filteredLayer.checked || filteredLayer.checked == null) {
        this.ActivateLayer(layer);
      } else {
        this.DeactivateLayer(layer);
      }
    }else{
      if(!environment.production) console.log("Undefined filteredSystemLayer");
    }
  }

  ActivateLayer(layer: LayerDTO, filtersApplied: CategoryFiltersDTO[] = null, isForceReload: boolean = false) {
    const filteredLayer = this.capas$.value.find((value) => {
      return value.name == layer.name;
    });

    if(!environment.production) console.log("ActivateSystemLayer capa", layer, this.capas$.value, filteredLayer);
    if (filteredLayer != undefined && !filteredLayer.checked) {

        if (layer.categoryId != undefined && layer.categoryId != null) {
          this.categoryLayerVerifyFilter( filteredLayer, filtersApplied, isForceReload);
        }else{
          // Desuscribirse de la suscripción anterior si existe para esta capa
          this.unsubscribeLayer(layer.name);
          this.setLayerLoading(layer, true);
          let obj: any;
          const subscription = this.layerService.GetLayerDataByNameGeoJSON( layer.name, filteredLayer.atributeDisplay).subscribe({
            next: (data) => {
              //verifica si el texto es un json minificado y obtiene el data
              data = this.checkMinifiedText(data);

              if (data.isSuccess && data.result != null && data.result != "") {
                if(!environment.production) console.log("FilteredLayer", filteredLayer);
                try{
                  if (filteredLayer.idLayerType == EnumLayerTypes.Geofence) {
                    var polygonCollection = JSON.parse(data.result);
                    if(!environment.production) console.log("Updating*******************************LayerGeoJson", layer.name + "-highSource", JSON.parse(data.result), polygonCollection);
                    if (polygonCollection != null && polygonCollection.features != null) {
                      var pointCollection = polygonCollection;
                      pointCollection.features = pointCollection.features.map((feature) => {
                        var centroid = this.mapHelper.getpolygonCentroid(feature);
                        centroid.properties = feature.properties;
                        return centroid;
                      });
                      if(!environment.production) console.log("Updating*******************************LayerGeoJson", layer.name + "-highSource", pointCollection);
                      
                      this.mapHelper.UpdateLayerGeoJson( layer.name + "-highsource", pointCollection );
                    }
                    // this.mapHelper.UpdateLayerGeoJson( layer.name + "-highsource", JSON.parse(data.result) );
                    this.mapHelper.UpdateLayerGeoJson( layer.name + "-source", JSON.parse(data.result) );
                  }else {
                    if(!environment.production) console.log("Updating*******************************LayerGeoJson", filteredLayer.name + "-source");
                    this.mapHelper.UpdateLayerGeoJson( filteredLayer.name + "-source", JSON.parse(data.result) );
                  }
                }catch(e){
                  if(!environment.production) console.log(e);
                }
                this.capas$.next(
                  this.capas$.value.map((v) =>
                    v.name === layer.name ? { ...v, isVisible: true, checked: true, isLoading: false } : v
                  )
                );
                this.unsubscribeLayer(layer.name);
              }else{
                this.setLayerLoading(layer, false);
                Sentry.captureMessage('PanelInternalLayer.ActivateLayer: isSuccess false', { level: 'warning', extra: { response: data } });
              }
            },
            error: (error) => {
              // TODO marca para complete despues
              console.error('Error al obtener datos de capa interna por nombre', error);
              this.setLayerLoading(layer, false);
              this.unsubscribeLayer(layer.name);
            }
          });
          
          this.layerSubscriptions.set(layer.name, subscription);
          
          this.setMaphelperActiveLayers();
        }

        
        setTimeout(() => {
          this.setLayerLoading(filteredLayer, false);
        }, 40000);
    }else{
      if(filteredLayer.checked && layer.categoryId != undefined && layer.categoryId != null){
        this.categoryLayerVerifyFilter( filteredLayer, filtersApplied, isForceReload);
      }
    }
  }

  DeactivateLayer(layer: LayerDTO) {
    this.unsubscribeLayer(layer.name);
    if(!environment.production) console.log("Desactivar capa", layer);
    const filteredLayer = this.capas$.value.find((value) => {
      return value.name == layer.name;
    });
    if (filteredLayer != undefined) {
      if (filteredLayer.idLayerType == EnumLayerTypes.Geofence) {
        this.mapHelper.UpdateLayerGeoJson( layer.name + "-highsource", this.mapHelper.Empty_GeoJson );
        this.mapHelper.UpdateLayerGeoJson( layer.name + "-source", this.mapHelper.Empty_GeoJson );
      } else {
        this.mapHelper.UpdateLayerGeoJson( layer.name + "-source", this.mapHelper.Empty_GeoJson );
      }
      this.capas$.next(
        this.capas$.value.map((v) =>
          v.name === layer.name ? { ...v, isVisible: false, checked: false, isLoading: false } : v
        )
      );

      this.setMaphelperActiveLayers();
    }
  }

  categoryLayerVerifyFilter(filteredLayer: LayerDTO, filtersApplied: CategoryFiltersDTO[] = null, isForceReload: boolean = false) {

    const category = JSON.parse(this.localStorageService.getListaCategorias())?.find((cat) => cat.id == filteredLayer.categoryId);
    if (category != null && category.layerFilter_IsFiltered && (filtersApplied == null || filtersApplied.length == 0)) {

      const savedFilters = this.panelLocationsService.tabCategoryFiltersSelected.value.filters?.find(t => t.id == category.id.toString());
      if(savedFilters != null && savedFilters.filtersSelected != null && savedFilters.filtersSelected.length > 0){
        filtersApplied = savedFilters.filtersSelected.map(filter => ({Key: filter.key, Value: filter.value, Module: filter.module || ''}));
        this.loadLayer(filteredLayer, filtersApplied, isForceReload);
        return;
      }
      // Agregar filtro dummy de Zonas
      // const filtersObjectUnique = { filters: [], selected: [] };
      // if(filtersObjectUnique.filters.findIndex(f => f.key == "Zonas") == -1)
      // filtersObjectUnique.filters.push({
      //   key: "Zonas",
      //   selected: "",
      //   values: ["METRO", "MEXICO", "CENTRO", "TOCUILA"],
      //   idLocationCategory: category.id,
      // });
  
      this.openCategoryFilter(category, filteredLayer);

    }else{
      this.loadLayer(filteredLayer, filtersApplied, isForceReload);
    }

  }

  openCategoryFilter(category: LocationCategoryDTO, filteredLayer: LayerDTO) {
    this.closeCaregoryFilter();
    const selectedFilters = this.panelLocationsService.tabCategoryFiltersSelected.value.filters?.find(t => t.id == category.id.toString())?.filtersSelected ?? [];
    
    this.filterDialog = this.dialog.open(FilterCategoriesComponent, {
      data: {
        moduleName: category.filterModule || null,
        filters: [],
        idLocationCategory: category.id,
        selected: selectedFilters,
      } as FilterDialogData,
      disableClose: false,
      panelClass: 'locations-filters-custom-popup',
      hasBackdrop: true,
      autoFocus: false,
      restoreFocus: false,
    });
  
    this.subscription_AfterClosed = this.filterDialog.afterClosed().subscribe((res: FilterDialogResult) => {
      if(!res || !res.search)
        return;

      if (res && res.search && res.filtersSelected?.length > 0) {
        const allFilters = this.panelLocationsService.tabCategoryFiltersSelected.value.filters.filter(t => t.id != category.id.toString());
        allFilters.push({id: category.id.toString(), filtersSelected: res.filtersSelected});
        this.panelLocationsService.tabCategoryFiltersSelected.next({filters: allFilters, categoryToBeAffected: category});
      }else{
        this.clearLayerFilter(filteredLayer);
        this.DeactivateLayer(filteredLayer);
      }
    });
  }

  clearLayerFilter(layer: LayerDTO) {
    const category = JSON.parse(this.localStorageService.getListaCategorias())?.find((cat) => cat.id == layer.categoryId);
    if (category == null)
      return;
    const allFilters = this.panelLocationsService.tabCategoryFiltersSelected.value.filters.filter(t => t.id != layer.categoryId.toString());
    console.log("pre filters", {filters: allFilters, categoryToBeAffected: category} );
    
    this.panelLocationsService.tabCategoryFiltersSelected.next({filters: allFilters, categoryToBeAffected: category});
    this.capas$.next(
      this.capas$.value.map((v) =>
        v.name === layer.name ? { ...v, checked: false, hasBeenFiltered: false, isLoading: false } : v
      )
    );
  }

  closeCaregoryFilter(){
    if(this.filterDialog != null){
      this.filterDialog.close();
    }
  }

  loadLayer(filteredLayer: LayerDTO, filtersApplied: CategoryFiltersDTO[], isForceReload: boolean = false) {
    if (!environment.production) console.log("Mostrar capa categoria", filteredLayer);
    this.unsubscribeLayer(filteredLayer.name);

    this.setLayerLoading(filteredLayer, true);
    const subscription = this.layerService.GetLayerByIdLocationCategoryGeoJSON(filteredLayer.categoryId, filtersApplied, isForceReload).subscribe({
        next: (data) => {
          if (!environment.production) console.log(filteredLayer);
          if (data.isSuccess) {
            if (filteredLayer.idLayerType == EnumLayerTypes.Geofence) {
              this.mapHelper.UpdateLayerGeoJson(
                filteredLayer.name + "-highsource",
                JSON.parse(data.result)
              );
              this.mapHelper.UpdateLayerGeoJson(
                filteredLayer.name + "-source",
                JSON.parse(data.result)
              );
            } else {
              this.mapHelper.UpdateLayerGeoJson(
                filteredLayer.name + "-source",
                JSON.parse(data.result)
              );
            }
            this.capas$.next(
              this.capas$.value.map((v) =>
                v.name === filteredLayer.name ? { ...v, checked: true, isLoading: false } : v
              )
            );

            this.setMaphelperActiveLayers();
            this.unsubscribeLayer(filteredLayer.name);
          } else {
            this.setLayerLoading(filteredLayer, false);
            Sentry.captureMessage('PanelInternalLayer.loadLayer: isSuccess false', { level: 'warning', extra: { response: data } });
          }
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error("Error al obtener capa por categoria", error);
          this.setLayerLoading(filteredLayer, false);
          this.unsubscribeLayer(filteredLayer.name);
        },
      });
    
    this.layerSubscriptions.set(filteredLayer.name, subscription);
  }


  GetSelectedLayers(){
    var capas = this.capas$.value.filter((layer) => {
      return layer.checked;
    });
    // this.activeLayer.checked = this.isActiveLayer;
    // this.filterLayer.checked = this.isFilterLayer;
    capas.push(this.activeLayer);
    capas.push(this.filterLayer);
    return capas;
  }

  DeactivateAllLayers(){
    this.capas$.value.forEach((layer) => {
      this.DeactivateLayer(layer);
    });
  }

  //limpia (apaga) todas las capas de categoria activas, se usa al cambiar de tab en el panel de activos
  resetCategoryLayers(){
    this.closeCaregoryFilter();
    this.capas$.value.filter((layer) => layer.categoryId != null).forEach((layer) => {
        this.unsubscribeLayer(layer.name);
        if (layer.checked || layer.isLoading)
          this.DeactivateLayer(layer);
      });
  }

  resetGPSLayers(clearFilteredLayer: boolean = true){
    this.clearGPSLayer();
    if (clearFilteredLayer)
      this.clearFilterLayer();
  }

  //indica si la capa de activos filtrados ya está cargada (o cargando) con esos mismos filtros
  isGPSFilteredLayerLoaded(filtersApplied: SelectedFilter[]): boolean {
    if (!this.filterLayer.checked && !this.filterLayer.isLoading)
      return false;

    return JSON.stringify(this.filterLayerFiltersBackup) == JSON.stringify(filtersApplied);
  }

  setMaphelperActiveLayers(){
    //capas fijas
    var activeLayers =  this.GetSelectedLayers();
    this.mapHelper.activeLayers = activeLayers;
  }

  setLayerLoading(layer: LayerDTO, isLoading: boolean) {
    if (this.capas$.value.some((v) => v.name === layer.name)) {
      this.capas$.next(
        this.capas$.value.map((value) =>
          value.name === layer.name ? { ...value, isLoading: isLoading } : value
        )
      );
    }
  }

  setLayerHasBeenFiltered(layer: LayerDTO, hasBeenFiltered: boolean) {
    if (this.capas$.value.some((v) => v.name === layer.name)) {
      this.capas$.next(
        this.capas$.value.map((value) =>
          value.name === layer.name ? { ...value, hasBeenFiltered: hasBeenFiltered } : value
        )
      );
    }
  }

  clearCheckedLayers(){
    this.capasPivote = this.capas$.value.filter((layer) => { return layer.checked});
    if(!environment.production) console.log("CapasPivote", this.capasPivote);
    this.capas$.value.forEach((layer) => {
      this.DeactivateLayer(layer);
    });
  }

  reactivateClearedLayers(){
    if(!environment.production) console.log("reactivateClearedLayers pivote", this.capasPivote);
    if (this.capasPivote.length > 0) {
      this.capasPivote.forEach((layer) => {
        const currentLayer = this.capas$.value.find((l) => l.name === layer.name);
        if (currentLayer && currentLayer.checked && currentLayer.isVisible) {
          return;
        }
        this.ActivateLayer(layer);
      });
    }
  }

  private unsubscribeLayer(layerName: string): void {
    const subscription = this.layerSubscriptions.get(layerName);
    if (subscription && !subscription.closed) {
      subscription.unsubscribe();
      this.layerSubscriptions.delete(layerName);
      if(!environment.production) console.log(`Desuscrito de la capa: ${layerName}`);
    }
  }

  private unsubscribeAllLayers(): void {
    this.layerSubscriptions.forEach((subscription, layerName) => {
      if (subscription && !subscription.closed) {
        subscription.unsubscribe();
      }
    });
    this.layerSubscriptions.clear();
    if(!environment.production) console.log('Todas las capas desuscritas');
  }
  
  checkMinifiedText(data: any): any {
    let isMinifiedText = true;
    let obj: any;
    try{
      obj = JSON.parse(data.toString());
      if(!environment.production) console.log("minified attempt", obj);
      if(obj && obj.IsSuccess != undefined && obj.Result != undefined){
        isMinifiedText = true;
      }else{
        isMinifiedText = false;
      }
    }catch(e){
      if(!environment.production) console.log(e);
      isMinifiedText = false;
    }
    if(isMinifiedText){
      data = new EstatusJSON();
      data.result = obj.Result;
      data.isSuccess = obj.IsSuccess;
      data.errors = obj.Errors;
      data.message = obj.Message;
    }
    return data;
  }

  //------------------Sección de capas de gps------------------


  addLayerActivos() {
    if(this.activeLayer.checked)
      return;

    this.ActivateGPSLayer(EnumPanelGPSTabTypes.Actualizados);
  }

  reloadGPSLayer(){
    if(!this.activeLayer.checked) return;

    this.ActivateGPSLayer(this.activeLayerGpsTypeSelected.value);
  }

  ActivateGPSLayer(gpsType: string) {
    this.unsubscribeLayer(this.activeLayer.name);

    if(gpsType != this.activeLayerGpsTypeSelected.value){
      this.activeLayerGpsTypeSelected.next(gpsType);
    }

    this.activeLayer.isLoading = true;
    let subscription: Subscription;
    switch (gpsType) {
      case EnumPanelGPSTabTypes.Actualizados:
        //GetActualizadosGeoJson
          subscription = this.locationService.GetActualizadosGeoJson().subscribe({
            next: (data) => {
              //verifica si el texto es un json minificado y obtiene el data
              data = this.checkMinifiedText(data);

              if (data.isSuccess && data.result != null && data.result != "") {
                this.loadStaticLayer(this.activeLayer, data, gpsType);
              }else{
                this.setLayerLoading(this.activeLayer, false);
                Sentry.captureMessage('PanelInternalLayer.ActivateGpsLayer.Actualizados: isSuccess false', { level: 'warning', extra: { response: data } });
                this.unsubscribeLayer(this.activeLayer.name);
              }
            },
            error: (error) => {
              console.error('Error al obtener datos de capa interna por nombre', error);
              this.setLayerLoading(this.activeLayer, false);
              this.unsubscribeLayer(this.activeLayer.name);
            }
          });
        break;
      case EnumPanelGPSTabTypes.Desactualizados:
        //GetDesactualizadosGeoJson
          subscription = this.locationService.GetDesactualizadosGeoJson().subscribe({
            next: (data) => {
              //verifica si el texto es un json minificado y obtiene el data
              data = this.checkMinifiedText(data);

              if (data.isSuccess && data.result != null && data.result != "") {
                this.loadStaticLayer(this.activeLayer, data, gpsType);
              }else{
                this.setLayerLoading(this.activeLayer, false);
                Sentry.captureMessage('PanelInternalLayer.ActivateGpsLayer.Desactualizados: isSuccess false', { level: 'warning', extra: { response: data } });
                this.unsubscribeLayer(this.activeLayer.name);
              }
            },
            error: (error) => {
              console.error('Error al obtener datos de capa interna por nombre', error);
              this.setLayerLoading(this.activeLayer, false);
              this.unsubscribeLayer(this.activeLayer.name);
            }
          });
        break;
      case EnumPanelGPSTabTypes.SinReporte:
        //GetSinReporteGeoJson
          subscription = this.locationService.GetSinReporteGeoJson().subscribe({
            next: (data) => {
              //verifica si el texto es un json minificado y obtiene el data
              data = this.checkMinifiedText(data);

              if (data.isSuccess && data.result != null && data.result != "") {
                this.loadStaticLayer(this.activeLayer, data, gpsType);
              }else{
                this.setLayerLoading(this.activeLayer, false);
                Sentry.captureMessage('PanelInternalLayer.ActivateGpsLayer.SinReporte: isSuccess false', { level: 'warning', extra: { response: data } });
                this.unsubscribeLayer(this.activeLayer.name);
              }
            },
            error: (error) => {
              console.error('Error al obtener datos de capa interna por nombre', error);
              this.setLayerLoading(this.activeLayer, false);
              this.unsubscribeLayer(this.activeLayer.name);
            }
          });
        break;
      default:
        //GetLayerGPSGeoJson
          // subscription = this.layerService.GetLayerGPSGeoJson().subscribe({
          //   next: (data) => {
          //     //verifica si el texto es un json minificado y obtiene el data
          //     data = this.checkMinifiedText(data);

          //     if (data.isSuccess && data.result != null && data.result != "") {
          //       this.loadStaticLayer(this.activeLayer, data);
          //     }else{
          //       this.setLayerLoading(this.activeLayer, false);
          //       Sentry.captureMessage('PanelInternalLayer.ActivateGpsLayer.Default: isSuccess false', { level: 'warning', extra: { response: data } });
          //       this.unsubscribeLayer(this.activeLayer.name);
          //     }
          //   },
          //   error: (error) => {
          //     console.error('Error al obtener datos de capa interna por nombre', error);
          //     this.setLayerLoading(this.activeLayer, false);
          //     this.unsubscribeLayer(this.activeLayer.name);
          //   }
          // });
        break;
    }

    this.layerSubscriptions.set(this.activeLayer.name, subscription);
    this.setMaphelperActiveLayers();

    setTimeout(() => {
      this.activeLayer.isLoading = false;
    }, 40000);
    
  }

  clearGPSLayer() {
    this.unsubscribeLayer(this.activeLayer.name);
    this.mapHelper.UpdateLayerGeoJson( this.activeLayer.mapSourceId[0], this.mapHelper.Empty_GeoJson );
    this.activeLayer.checked = false;
    this.activeLayer.isVisible = false;
    this.activeLayer.isLoading = false;
  }

  loadStaticLayer(layer: LayerDTO, data: any, gpsType?: string){
    if(!environment.production) console.log("activeLayer", this.activeLayer);
    try{
      var geoJson = JSON.parse(data.result);
      if (gpsType) 
        this.lastGpsLayerData = { gpsType, geoJson };
      this.mapHelper.UpdateLayerGeoJson( layer.mapSourceId[0], geoJson );
      layer.isVisible = true;
      layer.checked = true;
    }catch(e){
      if(!environment.production) console.log(e);
    }
    layer.isLoading = false;
    this.setMaphelperActiveLayers();
    this.unsubscribeLayer(layer.name);
  }


  activateGPSFilteredLayer(filtersApplied: SelectedFilter[]) {
    this.isFilterLayer = true;
    this.unsubscribeLayer(this.filterLayer.name);
          
    this.filterLayer.isLoading = true;
    let subscription: Subscription;


    this.filterLayerFiltersBackup = filtersApplied ? filtersApplied.map(f => ({ ...f })) : null;
    subscription = this.locationService.GetGeoJsonFilter(filtersApplied).subscribe({
      next: (data) => {
        //verifica si el texto es un json minificado y obtiene el data
        data = this.checkMinifiedText(data);

        if (data.isSuccess && data.result != null && data.result != "") {
          this.loadStaticLayer(this.filterLayer, data);
        }else{
          this.filterLayer.isLoading = false;
          Sentry.captureMessage('PanelInternalLayer.ActivateFilterLayer: isSuccess false', { level: 'warning', extra: { response: data } });
        }
      },
      error: (error) => {
        console.error('Error al obtener datos de capa interna por nombre', error);
        this.filterLayer.isLoading = false;
        this.unsubscribeLayer(this.filterLayer.name);
      }
    });

    this.layerSubscriptions.set(this.filterLayer.name, subscription);
    this.setMaphelperActiveLayers();

    setTimeout(() => {
      this.filterLayer.isLoading = false;
    }, 40000);
  }

  reloadGPSFilteredLayer(){
    if(this.filterLayerFiltersBackup != null){
      this.activateGPSFilteredLayer(this.filterLayerFiltersBackup);
    }
  }

  clearFilterLayer() {
    this.isFilterLayer = false;
    this.filterLayerFiltersBackup = null;
    this.unsubscribeLayer(this.filterLayer.name);
    this.mapHelper.UpdateLayerGeoJson( this.filterLayer.mapSourceId[0], this.mapHelper.Empty_GeoJson );
    this.filterLayer.checked = false;
    this.filterLayer.isVisible = false;
    this.filterLayer.isLoading = false;
  }

  clearLayers() {
    if(this.capas$.value.length == 0) 
      return;
    this.capas$.next(
      this.capas$.value.map((layer) => {
        this.unsubscribeLayer(layer.name);
        if(layer.mapSourceId != null && layer.mapSourceId != undefined && layer.mapSourceId.length > 0)
          this.mapHelper.UpdateLayerGeoJson( layer.mapSourceId[0], this.mapHelper.Empty_GeoJson );
        return { ...layer, checked: false, isVisible: false, isLoading: false };
      })
    );
  }
}
